/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { FC } from 'react';
import { DpContainer } from '@/components/blocks/DpContainer';

export const ItemWrap: FC<{ sx?: object }> = ({ ...props }) => <DpContainer {...props} />;

export const ItemWrapBreadcrumb: FC<{ sx?: object }> = ({ ...props }) => (
	<DpContainer framesx={{ marginTop: '15px' }} {...props} />
);
